/** Comparaison robuste nom d'equipe / departement (casse + espaces). */
export function normalizeOrgLabel(value: string): string {
  return value.toLowerCase().replace(/\s+/g, ' ').trim();
}

/** True si les deux libelles sont equivalentes apres normalisation. */
export function orgLabelsEquivalent(a: string, b: string): boolean {
  return normalizeOrgLabel(a) === normalizeOrgLabel(b);
}
